const toDataTest = (attribute: string): string => {
    return (attribute ?? "")
        .replace(/__/g, "")
        .replace(/\s+/g, "-")
        .replace(/[&\/\\#,+()$_~%.@'":*?<>{}]/g, "")
        .toLowerCase();
};

export { toDataTest };
